/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as TiresRouteImport } from "./routes/tires"
import { Route as JoinRouteImport } from "./routes/join"
import { Route as AuthedRouteImport } from "./routes/_authed"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as TuningTiresRouteImport } from "./routes/tuning.tires"
import { Route as ProfileUsernameRouteImport } from "./routes/profile/$username"
import { Route as DevNavRouteImport } from "./routes/dev.nav"
import { Route as DevIconsRouteImport } from "./routes/dev.icons"
import { Route as DevCardsRouteImport } from "./routes/dev.cards"
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback"
import { Route as AuthedDashboardRouteImport } from "./routes/_authed/dashboard"
import { Route as AuthedTournamentsIndexRouteImport } from "./routes/_authed/tournaments/index"
import { Route as AuthedReportsIndexRouteImport } from "./routes/_authed/reports/index"
import { Route as AuthedRankingsIndexRouteImport } from "./routes/_authed/rankings/index"
import { Route as AuthedDuelsIndexRouteImport } from "./routes/_authed/duels/index"
import { Route as AuthedAdminIndexRouteImport } from "./routes/_authed/admin/index"
import { Route as AuthedTournamentsTournamentIdRouteImport } from "./routes/_authed/tournaments/$tournamentId"
import { Route as AuthedReportsReportIdRouteImport } from "./routes/_authed/reports/$reportId"
import { Route as AuthedDuelsDuelIdRouteImport } from "./routes/_authed/duels/$duelId"

const TiresRoute = TiresRouteImport.update({
  id: "/tires",
  path: "/tires",
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: "/join",
  path: "/join",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const TuningTiresRoute = TuningTiresRouteImport.update({
  id: "/tuning/tires",
  path: "/tuning/tires",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileUsernameRoute = ProfileUsernameRouteImport.update({
  id: "/profile/$username",
  path: "/profile/$username",
  getParentRoute: () => rootRouteImport,
} as any)
const DevNavRoute = DevNavRouteImport.update({
  id: "/dev/nav",
  path: "/dev/nav",
  getParentRoute: () => rootRouteImport,
} as any)
const DevIconsRoute = DevIconsRouteImport.update({
  id: "/dev/icons",
  path: "/dev/icons",
  getParentRoute: () => rootRouteImport,
} as any)
const DevCardsRoute = DevCardsRouteImport.update({
  id: "/dev/cards",
  path: "/dev/cards",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTournamentsIndexRoute = AuthedTournamentsIndexRouteImport.update({
  id: "/tournaments/",
  path: "/tournaments/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsIndexRoute = AuthedReportsIndexRouteImport.update({
  id: "/reports/",
  path: "/reports/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRankingsIndexRoute = AuthedRankingsIndexRouteImport.update({
  id: "/rankings/",
  path: "/rankings/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDuelsIndexRoute = AuthedDuelsIndexRouteImport.update({
  id: "/duels/",
  path: "/duels/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: "/admin/",
  path: "/admin/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTournamentsTournamentIdRoute =
  AuthedTournamentsTournamentIdRouteImport.update({
    id: "/tournaments/$tournamentId",
    path: "/tournaments/$tournamentId",
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedReportsReportIdRoute = AuthedReportsReportIdRouteImport.update({
  id: "/reports/$reportId",
  path: "/reports/$reportId",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDuelsDuelIdRoute = AuthedDuelsDuelIdRouteImport.update({
  id: "/duels/$duelId",
  path: "/duels/$duelId",
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/join": typeof JoinRoute
  "/tires": typeof TiresRoute
  "/dashboard": typeof AuthedDashboardRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/dev/cards": typeof DevCardsRoute
  "/dev/icons": typeof DevIconsRoute
  "/dev/nav": typeof DevNavRoute
  "/profile/$username": typeof ProfileUsernameRoute
  "/tuning/tires": typeof TuningTiresRoute
  "/duels/$duelId": typeof AuthedDuelsDuelIdRoute
  "/reports/$reportId": typeof AuthedReportsReportIdRoute
  "/tournaments/$tournamentId": typeof AuthedTournamentsTournamentIdRoute
  "/admin/": typeof AuthedAdminIndexRoute
  "/duels/": typeof AuthedDuelsIndexRoute
  "/rankings/": typeof AuthedRankingsIndexRoute
  "/reports/": typeof AuthedReportsIndexRoute
  "/tournaments/": typeof AuthedTournamentsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/join": typeof JoinRoute
  "/tires": typeof TiresRoute
  "/dashboard": typeof AuthedDashboardRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/dev/cards": typeof DevCardsRoute
  "/dev/icons": typeof DevIconsRoute
  "/dev/nav": typeof DevNavRoute
  "/profile/$username": typeof ProfileUsernameRoute
  "/tuning/tires": typeof TuningTiresRoute
  "/duels/$duelId": typeof AuthedDuelsDuelIdRoute
  "/reports/$reportId": typeof AuthedReportsReportIdRoute
  "/tournaments/$tournamentId": typeof AuthedTournamentsTournamentIdRoute
  "/admin": typeof AuthedAdminIndexRoute
  "/duels": typeof AuthedDuelsIndexRoute
  "/rankings": typeof AuthedRankingsIndexRoute
  "/reports": typeof AuthedReportsIndexRoute
  "/tournaments": typeof AuthedTournamentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authed": typeof AuthedRouteWithChildren
  "/join": typeof JoinRoute
  "/tires": typeof TiresRoute
  "/_authed/dashboard": typeof AuthedDashboardRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/dev/cards": typeof DevCardsRoute
  "/dev/icons": typeof DevIconsRoute
  "/dev/nav": typeof DevNavRoute
  "/profile/$username": typeof ProfileUsernameRoute
  "/tuning/tires": typeof TuningTiresRoute
  "/_authed/duels/$duelId": typeof AuthedDuelsDuelIdRoute
  "/_authed/reports/$reportId": typeof AuthedReportsReportIdRoute
  "/_authed/tournaments/$tournamentId": typeof AuthedTournamentsTournamentIdRoute
  "/_authed/admin/": typeof AuthedAdminIndexRoute
  "/_authed/duels/": typeof AuthedDuelsIndexRoute
  "/_authed/rankings/": typeof AuthedRankingsIndexRoute
  "/_authed/reports/": typeof AuthedReportsIndexRoute
  "/_authed/tournaments/": typeof AuthedTournamentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/join"
    | "/tires"
    | "/dashboard"
    | "/auth/callback"
    | "/dev/cards"
    | "/dev/icons"
    | "/dev/nav"
    | "/profile/$username"
    | "/tuning/tires"
    | "/duels/$duelId"
    | "/reports/$reportId"
    | "/tournaments/$tournamentId"
    | "/admin/"
    | "/duels/"
    | "/rankings/"
    | "/reports/"
    | "/tournaments/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/join"
    | "/tires"
    | "/dashboard"
    | "/auth/callback"
    | "/dev/cards"
    | "/dev/icons"
    | "/dev/nav"
    | "/profile/$username"
    | "/tuning/tires"
    | "/duels/$duelId"
    | "/reports/$reportId"
    | "/tournaments/$tournamentId"
    | "/admin"
    | "/duels"
    | "/rankings"
    | "/reports"
    | "/tournaments"
  id:
    | "__root__"
    | "/"
    | "/_authed"
    | "/join"
    | "/tires"
    | "/_authed/dashboard"
    | "/auth/callback"
    | "/dev/cards"
    | "/dev/icons"
    | "/dev/nav"
    | "/profile/$username"
    | "/tuning/tires"
    | "/_authed/duels/$duelId"
    | "/_authed/reports/$reportId"
    | "/_authed/tournaments/$tournamentId"
    | "/_authed/admin/"
    | "/_authed/duels/"
    | "/_authed/rankings/"
    | "/_authed/reports/"
    | "/_authed/tournaments/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  JoinRoute: typeof JoinRoute
  TiresRoute: typeof TiresRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  DevCardsRoute: typeof DevCardsRoute
  DevIconsRoute: typeof DevIconsRoute
  DevNavRoute: typeof DevNavRoute
  ProfileUsernameRoute: typeof ProfileUsernameRoute
  TuningTiresRoute: typeof TuningTiresRoute
}

declare module "@tanstack/solid-router" {
  interface FileRoutesByPath {
    "/tires": {
      id: "/tires"
      path: "/tires"
      fullPath: "/tires"
      preLoaderRoute: typeof TiresRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/join": {
      id: "/join"
      path: "/join"
      fullPath: "/join"
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed": {
      id: "/_authed"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/tuning/tires": {
      id: "/tuning/tires"
      path: "/tuning/tires"
      fullPath: "/tuning/tires"
      preLoaderRoute: typeof TuningTiresRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/$username": {
      id: "/profile/$username"
      path: "/profile/$username"
      fullPath: "/profile/$username"
      preLoaderRoute: typeof ProfileUsernameRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dev/nav": {
      id: "/dev/nav"
      path: "/dev/nav"
      fullPath: "/dev/nav"
      preLoaderRoute: typeof DevNavRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dev/icons": {
      id: "/dev/icons"
      path: "/dev/icons"
      fullPath: "/dev/icons"
      preLoaderRoute: typeof DevIconsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dev/cards": {
      id: "/dev/cards"
      path: "/dev/cards"
      fullPath: "/dev/cards"
      preLoaderRoute: typeof DevCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/dashboard": {
      id: "/_authed/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/tournaments/": {
      id: "/_authed/tournaments/"
      path: "/tournaments"
      fullPath: "/tournaments/"
      preLoaderRoute: typeof AuthedTournamentsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/reports/": {
      id: "/_authed/reports/"
      path: "/reports"
      fullPath: "/reports/"
      preLoaderRoute: typeof AuthedReportsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/rankings/": {
      id: "/_authed/rankings/"
      path: "/rankings"
      fullPath: "/rankings/"
      preLoaderRoute: typeof AuthedRankingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/duels/": {
      id: "/_authed/duels/"
      path: "/duels"
      fullPath: "/duels/"
      preLoaderRoute: typeof AuthedDuelsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/admin/": {
      id: "/_authed/admin/"
      path: "/admin"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/tournaments/$tournamentId": {
      id: "/_authed/tournaments/$tournamentId"
      path: "/tournaments/$tournamentId"
      fullPath: "/tournaments/$tournamentId"
      preLoaderRoute: typeof AuthedTournamentsTournamentIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/reports/$reportId": {
      id: "/_authed/reports/$reportId"
      path: "/reports/$reportId"
      fullPath: "/reports/$reportId"
      preLoaderRoute: typeof AuthedReportsReportIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/duels/$duelId": {
      id: "/_authed/duels/$duelId"
      path: "/duels/$duelId"
      fullPath: "/duels/$duelId"
      preLoaderRoute: typeof AuthedDuelsDuelIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDuelsDuelIdRoute: typeof AuthedDuelsDuelIdRoute
  AuthedReportsReportIdRoute: typeof AuthedReportsReportIdRoute
  AuthedTournamentsTournamentIdRoute: typeof AuthedTournamentsTournamentIdRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedDuelsIndexRoute: typeof AuthedDuelsIndexRoute
  AuthedRankingsIndexRoute: typeof AuthedRankingsIndexRoute
  AuthedReportsIndexRoute: typeof AuthedReportsIndexRoute
  AuthedTournamentsIndexRoute: typeof AuthedTournamentsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDuelsDuelIdRoute: AuthedDuelsDuelIdRoute,
  AuthedReportsReportIdRoute: AuthedReportsReportIdRoute,
  AuthedTournamentsTournamentIdRoute: AuthedTournamentsTournamentIdRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedDuelsIndexRoute: AuthedDuelsIndexRoute,
  AuthedRankingsIndexRoute: AuthedRankingsIndexRoute,
  AuthedReportsIndexRoute: AuthedReportsIndexRoute,
  AuthedTournamentsIndexRoute: AuthedTournamentsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  JoinRoute: JoinRoute,
  TiresRoute: TiresRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  DevCardsRoute: DevCardsRoute,
  DevIconsRoute: DevIconsRoute,
  DevNavRoute: DevNavRoute,
  ProfileUsernameRoute: ProfileUsernameRoute,
  TuningTiresRoute: TuningTiresRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
